import { ComponentSpinner } from "@components/spinner";
import ContractReviewModal from "@panel/shared/contract/components/contract-review-modal";
import ContractsTable from "./components/contracts-table";
import usePublisherContractsPage from "./hooks/use-publisher-contracts-page";
import { PAGE_NOTE } from "./misc/constants";

const PublisherContracts = () => {
    const { loading, table, reviewModal, awaitingCount } = usePublisherContractsPage();

    // The awaiting-count line above the table is part of the page's message, so
    // the page waits as a whole rather than letting that line settle late.
    if (loading) {
        return (
            <div className="flex justify-center py-24">
                <ComponentSpinner />
            </div>
        );
    }

    return (
        <div className="p-6">
            {/* <KycBanner className="mb-6" /> */}

            <h1 className="text-2xl font-semibold tracking-tight">Contracts</h1>
            <p className="mt-1 text-sm text-muted">{PAGE_NOTE}</p>

            {awaitingCount > 0 && (
                <p className="mt-2 text-sm font-medium text-warning-foreground">
                    {awaitingCount} contract{awaitingCount === 1 ? "" : "s"} awaiting your signature.
                </p>
            )}

            <ContractsTable {...table} />

            <ContractReviewModal {...reviewModal} />
        </div>
    );
};

export default PublisherContracts;
